import * as yup from 'yup'
import i18n from '@/localization/i18n'
import constants from '@/utils/constants'

const t = i18n.global.t

const schema = yup.object().shape({
  email: yup.string().matches(constants.EMAIL_REGEX, t('w_msg_frmVal_emailFormat'))
    .required(t('w_msg_frmVal_required'))
})

export default schema